module.exports = __webpack_public_path__ + "img/cimb.5a05f14b.png";